export { default } from './News';
